import { Button, Tooltip } from "antd";
import "./DesignBatchBar.scss";
import MoveFolderIcon from "../icons/MoveFolderIcon";
import DeleteDesignIcon from "../icons/DeleteDesignIcon";
import CombineDesignsIcon from "../icons/CombineDesignsIcon";
import { DesignDto } from "../../generated/dashboard-client";
import { LoadingOutlined } from "@ant-design/icons";
import { maxDesignPages } from "../../util/constants";

export interface DesignBatchBarProps {
  onOrganizeClick: () => void;
  onDeleteClick: () => void;
  onCombineClick: () => void;
  onCancelClick: () => void;
  selected: DesignDto[];
  selectedPageCount: number;
  isCombineLoading: boolean;
}

export default function DesignBatchBar({
  onOrganizeClick,
  onDeleteClick,
  onCombineClick,
  onCancelClick,
  selected,
  selectedPageCount,
  isCombineLoading
}: DesignBatchBarProps) {
  return (
    <section className={"batch-bar"}>
      <ul>
        <li className="batch-move">
          <Button type={"link"} onClick={onOrganizeClick}>
            <MoveFolderIcon />
            Move
          </Button>
        </li>
        <li>
          <Button type={"link"} onClick={onDeleteClick}>
            <DeleteDesignIcon />
            Delete
          </Button>
        </li>
        <li>
          {selectedPageCount > maxDesignPages && !isCombineLoading && (
            <Tooltip
              placement="top"
              title={`You've reached the ${maxDesignPages} page maximum`}
              getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
            >
              <Button disabled={true} type={"link"} onClick={onCombineClick}>
                <CombineDesignsIcon />
                Combine
              </Button>
            </Tooltip>
          )}
          {selectedPageCount <= maxDesignPages && !isCombineLoading && (
            <Button
              disabled={selected.length < 2}
              type={"link"}
              onClick={onCombineClick}
            >
              <CombineDesignsIcon />
              Combine
            </Button>
          )}
          {isCombineLoading && (
            <Button
              type={"link"}
            >
              <LoadingOutlined />
              Combine
            </Button>
          )}
        </li>
        <li>
          <Button type={"link"} onClick={onCancelClick}>
            <span className={"x"}>×</span>
            Cancel
          </Button>
        </li>
      </ul>
    </section>
  );
}
